import './style.css';

const FullScreenLoading = () => {
  return (
    <div className="full-screen-loading ">
      <div className="uil-ring-css" style={{ transform: 'scale(0.79)' }}>
        <div />
      </div>
    </div>
  );
};

export default FullScreenLoading;
